export default "__VITE_ASSET__BBFtZjxB__"